import React, { Component, useState } from 'react';
import GoogleMapReact from 'google-map-react';

const AnyReactComponent = (props) => {
	const [active, setActive] = useState(false);

	return (
		<div className={`map-marker`}
			onMouseEnter={() => setActive(true)}
			onMouseLeave={() => setActive(false)}
			>
			{
				active &&
				<div className="info-window">
					<div className="title">{props.marker.Location}</div>
					<div className="desc">{props.marker.Address}</div>
					<div className="triangle"></div>
					<div className="inner-triangle"></div>
				</div>
			}
		</div>
	);
}

const ReactMap = ({
		center={
			lat: -37.813629,
			lng: 143.963058,
		},
		markers=[]
	}) => {

	return (
		// Important! Always set the container height explicitly
		<GoogleMapReact
			bootstrapURLKeys={{ key: 'AIzaSyCBVt9tsVCU8LFazxe-yILofaLKAlkqv0I' }}
			center={{
				lat: center.lat,
				lng: center.lng,
			}}
			yesIWantToUseGoogleMapApiInternals
			defaultZoom={5}
		>
			{
				markers && markers.length > 0 &&
				markers.map((e, i) => (
					<AnyReactComponent
						key={i}
						lat={e.Geolocation.lat}
						lng={e.Geolocation.lng}
						marker={e}
					/>
				))
			}
		</GoogleMapReact>
	)
}

export default ReactMap;
